import { UserConsumer } from './providers/UserProvider';
import React, { Component } from 'react';
import GroupPicker from './GroupPicker';

class GroupPickerContainer extends Component {

  render() {

    return (
      <UserConsumer>
        {({ user }) =>
          <GroupPicker user={user} {...this.props} />
        }
      </UserConsumer>
    );
  }
}

export default GroupPickerContainer;